# @TODO: Translations to align / review with other i18n files:
# Brief - Краткое описание (Бриф?)
# Production - Производство (Продакшн? Релиз?)
# Deliverables - Результаты - (done - aligned with other ru.yml)
# Delivery - Релиз (Результат?)
# UGC - КСП (контент сгенерированный пользователем)
# TAT - ВВЗ (время выполнения заказа)

ru:
  acceptInvite:
    continueWithFacebookText: 'или, продолжите с Facebook'
    firstNameLabel: Имя
    firstNamePlaceholder: Введите Ваше имя
    helloFNameText: 'Здравствуйте, {{fName}}'
    lastNameLabel: Фамилия
    lastNamePlaceholder: Введите Вашу фамилию
    otpLabel: Активировать 2FA
    passwordError: 'Пароль {{passwordError}}'
    passwordLabel: Пароль
    passwordShouldMatchError: Пароль должен совпадать с подтверждением
    provideYourDetailsText: 'Пожалуйста, заполните для того, чтобы продолжить:'
    signUpBtn: Войти
    welcomeToSRText: Добро пожаловать в Shuttlerock
  aiModels:
    label: Предпочитаемые модели ИИ
    category:
      IMAGE: Изображения
      VIDEO: Видео
      AUDIO: Аудио
      MUSIC: Музыка
      VOICE: Закадровый голос
    model:
      all: Любые модели ИИ
      none: Нет
      default: По-умолчанию
  authForm:
    emailLabel: Электронная почта
    emailPlaceholder: 'например, jane@example.com'
    forgotPasswordLink: Забыли пароль?
    notAUser: 'Пока нет регистрации? '
    passwordLabel: Пароль
    passwordPlaceholder: Введите пароль
    signInBtn: Войти
    signInWithEmail: Авторизоваться по электронной почте
  brandAssets:
    brandNotesLabel: Additional Notes
    selectedLogosLabel: Logo
    selectedOthersLabel: 'Fonts, Guidelines & Audio Files'
  clientForm:
    cancelBtn: Отмена
    cannotBeEditedWarning: Внимание - изменить это будет невозможно после создания
    clientCreated: Клиент создан.
    descriptionLabel: Описание
    descriptionPlaceholder: 'Введите короткий текст, описывающий клиента'
    facebookUrlPlaceholder: Введите ссылку на Facebook
    instagramUrlPlaceholder: Введите ссылку на Instagram
    nameLabel: Наименование клиента
    namePlaceholder: Введите наименование клиента
    otherUrlLabel: Ссылки
    otherUrlPlaceholder: 'Например, https://www.example.com/'
    regionLabel: Регион
    regionPlaceholder: Выберите регион
    submitBtn: Отправить
    twitterUrlPlaceholder: Введите ссылку на Twitter
    websiteUrlLabel: Сайт
    websiteUrlPlaceholder: Введите ссылку на сайт
    youtubeUrlPlaceholder: Введите ссылку на YouTube
  clientList:
    actionsLabel: Действия
    clientNameLabel: Наименование клиента
    editBtn: Редактировать
    emptyTableMessage: Нет клиентов для отображения. Нажмите кнопку 'Новый клиент' сверху чтобы добавить клиента.
    header: 'Клиенты {{name}}'
    manageUsersBtn: Пользователи
    newClientBtn: Новый клиент
  common:
    loadMoreBtn: Загрузить ещё
  exportSpinner:
    close: Закрыть
    exportSpinnerText: 'Экспортировано {{successCount}} из {{totalCount}}'
  footer:
    privacy: Конфиденциальность
    support: Поддержка
    supportRequest: 'Запрос в поддержку {{name}}'
    terms: Условия
  general:
    success: Успешно!
  header:
    signInLink: Войти
    signInText: Уже зарегистрированы?
  inputElement:
    inputPlaceholder: Введите Ваш ответ...
  instantAnswer:
    requiredFieldText: Это поле должно быть заполнено
  orderBriefAnswerList:
    label:
      assetSources: Дополненные ресурсы
    assetSources:
      supplementAssets: 'Дополнить предоставленные ресурсы:'
      stockAssets: Имеющиеся ресурсы
      website: Любые материалы из моих руководств по бренду, веб-сайта или социальных платформ, ссылки на которые приведены выше
      aiEnhanced: Ресурсы, улучшенные ИИ
      none: Использовать только предоставленные мной ресурсы
    utility:
      assistant: Ассистент
      notes: Заметки
      summary: Содержание
      support: Поддержка
    STATIC: Статичный
    actionsSave: Сохранить и выйти
    actionsSubmit: Утвердить Краткое описание
    additionalDetails: Дополнительные инструкции
    additionalNotes: Дополнительные заметки
    artDirectorLabel: Арт-директор
    artDirectorUpdated: Обновлено Арт-директором
    assetNotes: Заметки ресурсов
    assetsZipGeneratingTooltip: Архив ресурсов генерируется
    audio: Аудио
    base: Основа
    baseCopyTranslationLabel: 'Копия основы - {{language}}: '
    brandAssets: Ресурсы бренда
    brandDescription: Описание бренда
    brandName: Бренд
    brandPersonality: Индивидуальность бренда
    brandRequirements: Юридические и креативные требования
    briefCsReviewAlertTitle: В настоящее время данное Краткое описание находится на рассмотрении и может быть одобрено только после того, как будет передано на рассмотрение в Производство.
    briefCsReviewInformation: Чтобы переместить Краткое описание на рассмотрение в Производство, перейдите к Краткому описанию и нажмите кнопку «Отправить на рассмотрение в Производство».
    briefSubmitted: 'Это Краткое описание было утверждено и больше не может быть отредактировано. Если вам нужно обновить Краткое описание, пожалуйста, свяжитесь с вашим Креативным Стратегом'
    briefUgcAlertTitle: В этом Кратком описании есть требования КСП, и в настоящее время он находится в {{state}}.
    briefUgcInformation: Это может быть перемещено в раздел «Рассмотрения производства» только после завершения создания КСП.
    campaignDetails: Подробности кампании
    channels: Каналы
    clientAndBrandDetails: Сведения о клиенте и бренде
    clientDescription: Описание клиента
    clientName: Клиент
    collapseAll: Свернуть все
    disclaimer: Отказ от ответственности
    expandAll: Развернуть все
    conceptIdea: Концепция идеи
    conceptBasics: Основы
    conceptVariation: 'Вариант концепции {{ index }}'
    confirmOrderBtnLabel: Утвердить Краткое описание
    confirmOrderCancelBtnLabel: Отмена
    confirmOrderModalTitle: Вы уверены, что хотите одобрить это Краткое описание?
    confirmSubmitOrderModalInformation: '<0>Как только вы нажмете <1>Утвердить</1>, вы больше не сможете редактировать Краткое описание.</0>'
    confirmSubmitOrderModalTitle: Вы уверены?
    copyFilenameError: 'Не удалось скопировать имя файла в буфер обмена'
    copyFilenameSuccess: 'Имя файла скопировано в буфер обмена!'
    details: Подробности
    detailsLinkLabel: Показать подробности
    dimension: Размеры
    downloadAssets: Скачать ресурсы
    editLinkLabel: Редактировать
    editNotesBtnLabel: Редактировать заметки
    editNotesClickOutside: Щелкните за пределами текстовой области, чтобы сохранить заметки.
    editNotesPlaceholder: Нажмите кнопку редактирования, чтобы добавить заметки в эту область. Когда вы закончите, вы можете нажать в любом месте за пределами текстового поля, чтобы сохранить свои заметки.
    fileName: Имя файла
    group: Группа
    internalNotesOnly: Внутренние заметки
    languageBaseLabel: 'Язык:'
    languageLabel: Выберите языки, для которых вам требуются переводы
    languagesVariationInformation: Позднее вас попросят предоставить переведенную копию.
    languagesVariationInformationTitle: Вариант перевода
    logo: Логотип
    notesUpdated: Заметки обновлены
    orderDetails: Подробности проекта
    orderName: 'Имя поекта:'
    orderNotes: Заметки проекта
    orderNotificationInformation: 'Вы автоматически будете получать по электронной почте все обновления об этом проекте, а также о назначенных партнерах клиента и креативных специалистах.'
    orderNotificationTitle: Кто должен получать уведомления о готовности этого проекта?
    platformSpecifics: Особенности платформы
    productionBrief: Краткое описание для производства
    productionNotesPlaceholder: ' '
    productionTranslationLabel: 'Перевод для производства: '
    projectOverviewBtn: Обзор проекта
    region: Регион
    reviewYourDetails: Проверьте данные вашего Краткого описания перед отправкой. После отправки вы больше не сможете редактировать Краткое описание.
    saveNotes: Сохранить заметки
    messaging: Сообщения
    selectedAssets: Ресурсы
    submitBtn: Утвердить
    submittedDateLabel: 'Дата утверждения:'
    delivery:
      deliveryDueDateLabel: 'Следующий релиз:'
      deliveryDueDateLinkLabel: Узнайте как
      nextDeliveryTooltip: '<0>{{linkText}}</0> рассчитано' # @TODO: Verify the context
      changeDateLabel: Изменить дату
      adjustedDeliveryLabel: 'Скорректированный релиз: '
      reasonLabel: Причина корректировки доставки
      reasonPlaceholderLabel: Найдите или введите причину
      requiredLabel: Необходимо
      saveBtnLabel: Сохранить
      toast:
        success: Следующий релиз скорректирован
        saveError: Ошибка сохранения
      reason:
        briefClarification: Требуется краткое пояснение
        complexDeliverables: Сложные результаты
        complexRevision: Сложные редакция
        storyboard: Требуется раскадровка
        creativeRework: Креативная переделка
        midProductionChange: Запрос на внесение изменений в середине производства
        expeditedProject: Ускоренный проект
        splitDelivery: Раздельный релиз
        workingFileTat: Рабочий файл ВВЗ
        specialFormat: Специальный формат Индивидуального графика
        regionalHoliday: Региональный праздник (Клиента)
    summaryTitle: Краткое описание
    tableDetails: Детали
    tableDimension: Размеры (пиксели)
    tableLength: Максимальная продолжительность
    tablePlatform: Платформа
    totalDeliverables: 'Всего результатов: {{count}}'
    totalOrderDeliverables: Общий порядок результатов
    translation: 'Перевод на {{ language }}'
    updateTranslationBtnLabel: Перевести копию
    updateTranslationSuccessMessage: Переводы были обновлены
    updateTrelloCardBtnLabel: Обновить Trello
    updateTrelloSuccessMessage: Карточка Trello была обновлена
    updatingTrelloBtnLabel: Обновляется...
    urlFacebook: Facebook
    urlInstagram: Instagram
    urlOther: Другое
    urlTwitter: Twitter
    urlWebsite: Веб-сайт
    urlYoutube: YouTube
    verticalName: Вертикальный
    voiceOver: 'Голос за кадром'
    websites: 'Каналы клиента: '
  orderDeliverableList:
    Approve Creatives: Одобрить контент
    Business account: Бизнес аккаунт
    Download All: Скачать всё
    Modal: Модальное окно
    Order Now: Заказать сейчас
    Select a business account: Выбрать бизнес аккаунт
    View Demo: Смотреть демо
    View Playdeck: Смотреть Playdeck
    accessRevoked: Доступ был отозван.
    automaticOrderApprovalText: 'Этот заказ будет автоматически принят {{ when }}.'
    chooseExistingFolder: Выбрать существующую папку
    close: Закрыть
    continue: Продолжить
    createNewFolder: Создать папку
    creativeFolder: Папка
    dropboxExportComplete: Выгружено в Dropbox успешно.
    emailInstructions: Отправить инструкции
    exportSpinnerText: 'Экспортировано {{successCount}} из {{totalCount}}'
    mustBeLoggedInToApproveText: но Вы должны войти в систему чтобы принять заказ.
    newFolderName: Название новой папки
    orderApproveActionsText: 'Когда Вы примете этот заказ, Вы сможете скачать Ваш контент или экспортировать его в другие сервисы.'
    proceedToProduction: Перейти к полноценному production
    revisionConfirmationText: Ваш заказ в работе. Вы получите письмо когда Ваша версия будет готова.
    revisionRequestConfirmationBtn: Запросить версию
    revisionRequestConfirmationTitle: Вы уверены?
    revokeAccessToMyYoutubeAccount: Отозвать доступ к моему аккаунту YouTube
    sendExportInstructionsToSomeoneElse: Отправить инструкции по экспорту кому-либо ещё
    sendInstructionsToSomeoneElse: Отправить инструкции кому-либо ещё
    shareUrlText: Вы можете поделиться этим URL с кем угодно
    youHaveWithCount_one: '{{revisionLeft}} версия из {{maxNumeRevisions}} осталась'
    youHaveWithCount_other: '{{revisionLeft}} версий из {{maxNumeRevisions}} осталось'
    youtubeMenuModalHeading: Каким образом Вы хотели бы экспортировать Ваши материалы?
  orderDeliverableUpload:
    activeAdmin: 'Текущий Администратор:'
    cannotAddDeliverableErrorDesc: 'Результаты больше не могут быть загружены для этого заказа.'
    cannotAddDeliverableErrorTitle: 'Эта страница больше не доступна:'
    conceptOptionLabel: 'Концепт {{number}} - {{name}}'
    conceptHeaderLabel: 'Концепт'
    confirmDelete: Удалить
    confirmDeleteText: Вы уверены, что хотите удалить этот результат?
    confirmDeleteTitle: Удалить результат?
    containsAiHeaderLabel: Включает ИИ
    containsAiHeaderTooltip: 'Выберите "да", если какие-либо материалы (изображения, аудио, видео или музыка), используемые в этом концепте, были сгенерированы или значительно изменены (к примеру, сгенерированный фон, размещение продукта и т.п.) с использованием ИИ сервисов (таких как Midjourney, Luma AI, ElevenLabs или Sora).'
    currentState: 'Текущее состояние:'
    currentWorkflowStep: 'Текущий шаг рабочего процесса:'
    deletePermissionError: Извините, у вас нет разрешения на архивацию этого материала.
    deliverableFormatHeaderLabel: Формат
    deliverableNameHeaderLabel: Имя результата
    deliverableFormat: Формат результата
    deliverableFormatErrorRequired: Пожалуйста, введите правильный формат для результата
    deliverableName: Имя результата
    deliverables: Результаты
    deliveryPageLink: 'Ссылка на страницу результата:'
    duplicateFileFoundDialogTitleDeprecated: 'Найден дубликат файла'
    duplicateFileFoundDialogContentDeprecated: 'Файл, который вы пытаетесь загрузить, имеет те же атрибуты файла, что и файл “{{fileName}}” который уже загружен в этот проект. Хотите заменить этот файл тем, который вы загружаете?'
    duplicateFileFoundDialogActionReplaceDeprecated: 'Заменить файл'
    duplicateFileFoundDialogActionCancelDeprecated: Отмена
    duplicateFileFoundDialogTitle: 'Дубликаты файлов'
    duplicateFileFoundDialogContent: Обнаружено несколько файлов с одинаковым набором атрибутов.
    duplicateFileFoundDialogKeep: Какой файл Вы предпочетаете оставить?
    duplicateFileFoundDialogNew: Новый
    duplicateFileFoundDialogExisting: Существующий
    duplicateFileFoundDialogActionContinue: Продолжить
    duplicateFileFoundDialogActionProceed: Продолжить
    duplicateFileFoundDialogActionCancel: Отмена
    duplicateFileFoundDialogOptionUploadNewVersionTitle: Загрузить новый файл как новую версию
    duplicateFileFoundDialogOptionUploadNewVersionDescription: Новый файл будет добавлен как новая версия к существующему.
    duplicateFileFoundDialogOptionKeepOriginalTitle: Оставить исходный и отклонить новый
    duplicateFileFoundDialogOptionKeepOriginalDescription: Без изменений. Новый файл будет отклонен.
    duplicateFileFoundDialogOptionKeepBothTitle: Оставить оба
    duplicateFileFoundDialogOptionKeepBothDescription: Оба файла будут сохранены. Новому файлу будет добавлен номер «Unit».
    durationHeaderLabel: Длительность
    failedUpload: Ошибка загрузки
    failedUploadUnsupported: Ошибка загрузки - неподдерживаемый тип файла.
    bitrate: '{{bitrate}}kbps'
    fps: '{{fps}}fps'
    fileTypeHeaderLabel: Тип файла
    heightHeaderLabel: Высота
    heroLabel: 'Герой {{position}}'
    heroHeaderLabel: Герой
    languageHeaderLabel: Язык
    loading: Загрузка
    lockedTooltip: Утверждено
    measurementUnitHeaderLabel: Единица измерения
    audioUrlHeaderLabel: URL-адрес аудио
    newAssetLabel: Загрузить файлы для этого проекта
    nextWorkflowStep: ' Следующий шаг рабочего процесса:'
    originalCreativeOptionLabel: Оригинальный креатив
    platformHeaderLabel: Платформа
    revisionHeaderLabel: Ревизия
    saveOrderBtn: Сохранить проект
    saved: Проект был успешно сохранен
    state: Состояние
    titleErrorRequired: Это поле обязательно к заполнению.
    unitHeaderLabel: Часть
    uploadErrorText: ' {{uploadErrorCount}} отсутствуют обязательные поля.'
    uploadAudioUrlInvalidText: ' {{audioUrlInvalidCount}} Недействительные URL-адреса аудио.'
    uploadHeroMissingText: ' Концепт {{heroMissingConcepts}} требует указания Героя.'
    uploadSuccessText: ' {{uploadSuccessCount}} Успешно загружено.'
    variantHeaderLabel: Вариант
    versionHeaderLabel: Версия
    widthHeaderLabel: Ширина
    yes: Да
    utility:
      assistant: Ассистент
      summary: Краткое содержание
      support: Поддержка
    containsAIOptions:
      YES: Да, включает ИИ
      NO: Нет
      UNSURE: Не уверен
    audioTypeNoAudio: Без фоновой музыки
    audioTypeClientProvided: Аудио предоставлено клиентом
  orderList:
    searchPlaceholder: Поиск
    statusPlaceholder: Любой статус
  orderListTable:
    actions: Действия
    actionsContinueOrder: Продолжить заказ
    actionsDelete: Удалить
    actionsReviewCreatives: Посмотреть результаты
    actionsViewCreatives: Просмотр результатов
    date: Дата
    emptyTableMessage: Нет заказов для отображения. Нажмите кнопку 'Новый заказ' сверху чтобы разместить новый заказ.
    modalDeleteConfirmationButton: Удалить заказ
    modalDeleteConfirmationText: Этот черновик будет безвозвратно удалён. Вы уверены что хотите продолжить?
    orderName: Заказ Name
    status: Статус
  orderSummary:
    Back: Назад
    Edit: Редактировать
    Update: Обновить
    cancelBtn: Отмена
    orderNotificationTitle: Кто должен получить уведомление о готовности этого заказа?
    submitBtn: Отправить заказ
  passwordStrength:
    Password Strength: Стойкость пароля
  productDetails:
    5 days: 5 дней
    More: Ещё
    Order Now: Заказать сейчас
    Revision Icon: Ревизия
    Turnaround: Срок
    Turnaround Icon: Срок
    maxNumRevisionsWithCount_one: '{{count}} раунд'
    maxNumRevisionsWithCount_other: '{{count}} раундов'
    '{{turnaroundDays}} days': '{{turnaroundDays}} дней'
  signUpForm:
    back: Назад
    emailErrorRequired: Это обязательное поле.
    emailPlaceholder: Адрес электронной почты
    firstNameErrorRequired: Это обязательное поле.
    firstNamePlaceholder: Имя
    heading: Зарегистрироваться
    lastNameErrorRequired: Это обязательное поле.
    lastNamePlaceholder: Фамилия
    passwordErrorRequired: Это обязательное поле.
    signUpBtn: Зарегистрироваться
  translatable:
    inputPlaceholder: Введите ответ тут...
  uploadElement:
    uploaderErrorMessage: 'С отображением загрузчика файлов возникла проблема, пожалуйста, свяжитесь с администратором.'
  uploader:
    file: файл
    fileLimitHitWithCount_one: 'Вы можете загрузить только {{count}} файла'
    fileLimitHitWithCount_other: 'Вы можете загрузить только {{count}} файл'
    file_other: файлы
    noMoreFilesMessage: Вы не можете загрузить больше файлов
    uploaderText: 'Перетащите {{files}} сюда или щёлкните чтобы открыть файловый диалог {{browse}}'
  userInvite:
    cancelBtn: Отмена
    emailLabel: Электронная почта
    emailPlaceholder: ivan@example.ru
    firstNameLabel: Имя
    firstNamePlaceholder: Иван
    lastNameLabel: Фамилия
    lastNamePlaceholder: Иванов
    submitBtn: Отправить приглашение
  userList:
    email: Электронная почта
    emptyTableMessage: Нет пользователей для отображения. Нажмите кнопку 'Новый пользователь' выше чтобы добавить нового пользователя.
    newUser: 'Новый пользователь '
    userName: Имя пользователя
